let isOnlineGlobal = window.navigator.onLine;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(isOnlineGlobal));

export const subscribeToNetwork = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const checkNetworkStatus = () => {
  const currentStatus = window.navigator.onLine;
  if (currentStatus !== isOnlineGlobal) {
    isOnlineGlobal = currentStatus;
    notify();
  }
  return currentStatus;
};

window.addEventListener("online", () => {
  isOnlineGlobal = true;
  notify();
});

window.addEventListener("offline", () => {
  isOnlineGlobal = false;
  notify();
});
